import {AxiosPromise} from 'axios';
import {createAction, createReducer} from 'redux-act';

import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

import {StoreInfoType} from './storeInfoType';

const DEFAULT_PHONE = '1-844-244-1186';
const DEFAULT_EMAIL = 'service@glassesusa.com';
const DEFAULT_WORKING_HOURS = 'All Day. Every Day. 24-7';

export const initialState: StoreInfoType = {
    phones: {
        homepage: DEFAULT_PHONE,
        cart: DEFAULT_PHONE,
        default: DEFAULT_PHONE,
    },
    fax: '',
    email: DEFAULT_EMAIL,
    working_hours: DEFAULT_WORKING_HOURS,
    prescription_email: '',
    logo: {
        src: '',
        alt: '',
        video: '',
    },
    address: '',
    status: '',
    social: {},
};

/**
 * Store info from backend
 */
export const fetchStoreInfo = createAction<AxiosPromise<StoreInfoType>>('GET_STORE_INFO', () =>
    instanceGusaBackend({
        method: 'get',
        url: ENDPOINTS.GET_STORE_INFO,
    }),
);

/**
 * Store info reducer
 */
export const storeInfo = createReducer<StoreInfoType>({}, initialState).on(
    `${fetchStoreInfo}_FULFILLED`,
    (state, payload: {data: Partial<StoreInfoType>}): StoreInfoType => ({
        ...state,
        ...payload.data,
        status: 'fulfilled',
    }),
);
